/*
 Convention: https://docs.google.com/document/d/1ePqfM41II2CNBYpTuOgjLZafRkn6vABQ5NF40JGER1E/edit
 Review Reference: https://docs.google.com/document/d/1Diu8ZwKXPOWCsH2ry8rufCYADGFcHtR4MY3k1c3Ypes/edit

 ! Review
 TODO Disbursement - Remove all redux, use SWR instead
 */
import keyMirror from 'src/utilities/keyMirror';

const PREFIX = 'BRIDGED';

export const ACTION_TYPES = keyMirror({
  // Balance Detail
  [`${PREFIX}_BALANCE_DETAIL`]: null,
  [`${PREFIX}_BALANCE_DETAIL_SUCCESS`]: null,
  [`${PREFIX}_BALANCE_DETAIL_FAILED`]: null,

  // Cash In Detail
  [`${PREFIX}_CASH_IN_LIST`]: null,
  [`${PREFIX}_CASH_IN_LIST_SUCCESS`]: null,
  [`${PREFIX}_CASH_IN_LIST_FAILED`]: null,

  // Cash Out Detail
  [`${PREFIX}_CASH_OUT_LIST`]: null,
  [`${PREFIX}_CASH_OUT_LIST_SUCCESS`]: null,
  [`${PREFIX}_CASH_OUT_LIST_FAILED`]: null,

  // Tx Summary Detail
  [`${PREFIX}_TX_SUMMARY_LIST`]: null,
  [`${PREFIX}_TX_SUMMARY_LIST_SUCCESS`]: null,
  [`${PREFIX}_TX_SUMMARY_LIST_FAILED`]: null,

  // Tx Detail
  [`${PREFIX}_TX_DETAILS_LIST`]: null,
  [`${PREFIX}_TX_DETAILS_LIST_SUCCESS`]: null,
  [`${PREFIX}_TX_DETAILS_LIST_FAILED`]: null,
});
